import { Country, PhoneNumber } from '@shared/types'

import { trimPhoneNumber } from './form'

export const getNationalityNames = (nationalities: string[], countries: Country[]): string => {
  if (!nationalities?.length) {
    return '-'
  }
  return nationalities
    .map((nationality) => countries.find((country) => country.alpha2Code === nationality)?.name ?? nationality)
    .join(', ')
}

export const getTrimmedPhoneNumberInfo = <T extends PhoneNumber>(phoneNumber: T): T => {
  return {
    ...phoneNumber,
    phoneNumber: trimPhoneNumber(phoneNumber.phoneNumber),
  }
}

export const getCountryCodeWithLeadingPlus = (countryCode: string): string => {
  return countryCode?.startsWith('+') ? countryCode : `+${countryCode}`
}
